import { useApi } from '@hero/context';

import type {
  UseAccountTransactionApi,
  UseAccountTransactionListApi,
} from './types';
import { useInfiniteQueryAPI, useQueryAPI } from '../../utils';

/**
 * Get a single `AccountTransaction` by id.
 *
 * Hook API: {@link UseAccountTransactionApi}
 */
export const useAccountTransactionApi: UseAccountTransactionApi = (id, apiConfig) => {
  const api = useApi();
  return useQueryAPI({
    entity: 'accountTransaction',
    apiFn: api.payment.getAccountTransaction,
    query: undefined,
    singleIdQuery: id,
    apiConfig,
    isEnabled: () => !!id,
  });
};

/**
 * Infinite list of `AccountTransaction` rows for the viewer.
 *
 * Hook API: {@link UseAccountTransactionListApi}
 */
export const useAccountTransactionListApi: UseAccountTransactionListApi = (
  query,
  apiConfig,
) => {
  const api = useApi();
  return useInfiniteQueryAPI({
    entity: 'accountTransaction',
    apiFn: api.payment.getAccountTransactions,
    query,
    apiConfig,
  });
};
